module.exports = __webpack_public_path__ + "assets/img/3d18-bs.svg";